import { createElement } from 'react'
import type { ReactNode } from 'react'

const URL_REGEX = /(https?:\/\/[^\s<>"')\]]+)/g

/**
 * Transform plain text into an array of strings and clickable <a> elements.
 * URLs matching http/https are rendered as links opening in a new tab.
 */
export function linkifyText(text: string): ReactNode[] {
  const parts: ReactNode[] = []
  let lastIndex = 0
  let match: RegExpExecArray | null
  let key = 0

  URL_REGEX.lastIndex = 0
  while ((match = URL_REGEX.exec(text)) !== null) {
    const url = match[1]
    const index = match.index

    // Text before the URL
    if (index > lastIndex) {
      parts.push(text.slice(lastIndex, index))
    }

    // The URL as a clickable link
    parts.push(
      createElement(
        'a',
        {
          key: `link-${key++}`,
          href: url,
          target: '_blank',
          rel: 'noopener noreferrer',
          style: {
            color: 'var(--color-accent)',
            textDecoration: 'underline',
            textUnderlineOffset: '2px',
          },
        },
        url,
      ),
    )

    lastIndex = index + url.length
  }

  // Remaining text after last URL
  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex))
  }

  return parts.length > 0 ? parts : [text]
}
